"use strict";

exports.__esModule = true;
exports.XAxisLabel = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var XAxisLabelContainer = _styledComponents["default"].div.withConfig({
  displayName: "XAxisLabel__XAxisLabelContainer",
  componentId: "sc-1lo0a9m-0"
})(["left:0;position:sticky;width:", "px;text-align:center;height:", "px;display:flex;align-items:flex-end;justify-content:center;padding-bottom:", "px;'"], function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  return props.paddingBottom;
});
var XAxisLabel = exports.XAxisLabel = /*#__PURE__*/_react["default"].memo(function (props) {
  var hideXUnits = props.hideXUnits,
    hideXAxis = props.hideXAxis,
    scrollableWidth = props.scrollableWidth,
    XAxisLabelHeight = props.XAxisLabelHeight,
    padding = props.padding,
    xAxisLabel = props.xAxisLabel,
    bodyWidth = props.bodyWidth;
  return !(hideXUnits || hideXAxis) && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: scrollableWidth,
      height: XAxisLabelHeight
    }
  }, /*#__PURE__*/_react["default"].createElement(XAxisLabelContainer, {
    width: bodyWidth,
    height: XAxisLabelHeight,
    paddingBottom: padding
  }, xAxisLabel));
});